import { render, staticRenderFns } from "./listInvestorParticularsProject.vue?vue&type=template&id=3c0b325d&scoped=true"
import script from "./listInvestorParticularsProject.vue?vue&type=script&lang=js"
export * from "./listInvestorParticularsProject.vue?vue&type=script&lang=js"
import style0 from "./listInvestorParticularsProject.vue?vue&type=style&index=0&id=3c0b325d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b325d",
  null
  
)

export default component.exports